/** Home hero: the intro, the story told while scrolling, and the closing wordmark. */
import { ACTIONS } from '../site'

export const HERO = {
  eyebrow: 'MeetNPlan',
  title: 'Your office runs on meetings.',
  text: 'Here is how MeetNPlan keeps them running.',
  scroll: 'Scroll',
  // The story told while scrolling, one statement per screen. Each title's
  // last word gets the blue marker; the last statement leads into the wordmark.
  frames: [
    {
      title: 'It starts with a free room.',
      text: 'See what is open and book it in a tap.',
    },
    {
      title: 'Then your guest arrives.',
      text: 'Reception signs them in and lets the host know.',
    },
    {
      title: 'HR stays in the loop.',
      text: 'Requests are approved before anything is confirmed.',
    },
    {
      title: 'Your team stays in touch.',
      text: 'Messages and group chats, right where the meeting is.',
    },
    {
      title: 'And it all lands in your calendar.',
      text: 'Every booking syncs to Google Calendar.',
    },
    { title: 'All of it, in one app.', text: 'Say hello to…' },
  ],
  wordmark: 'MEETNPLAN',
  closing: 'One app for every meeting, room and visitor.',
  primary: ACTIONS.demo,
  secondary: { label: 'See the product', href: '/#product' },
}
